import _ from 'lodash';
import angular from 'angular';
import './style.scss';
import template from './template.html';
import {
    DynamicCriteriaComponent,
    DynamicCriteriaComponentConfiguration,
} from '../dynamicCriteria/dynamicCriteriaComponent';
import * as searchItemsPriority from '../../constants/searchItemsPriority';
import Logger from '../logger';

export class DynamicCriteriaWithGroupsComponent extends DynamicCriteriaComponent {
    dragedItem;
    selectedItems = new Set();
    isEditActionEnabled = false;
    isGroupingActionEnabled = false;

    constructor(
        $scope,
        $uibModal,
        DynamicCriteriaWithGroupsService,
        dynamicDataService,
        staticDataService,
        $timeout,
        RouteService,
        searchCacheService,
        utils,
        $element,
        TFTTagsService,
    ) {
        super(dynamicDataService, staticDataService, $timeout, RouteService, searchCacheService, utils, $element, $scope);
        this.$scope = $scope;
        this.$uibModal = $uibModal;
        this.DynamicCriteriaWithGroupsService = DynamicCriteriaWithGroupsService;
        this.searchCacheService = searchCacheService;
        this.tftTagsService = TFTTagsService;
    }

    initData() {
        this.showAdd = false;
        this.showDropDown = false;
        this.showSubCriteria = false;
        this.requiredIndexes = [];
        if (this.createJob && this.data.title === 'LOCATION') {
            this.inputReadyOnly = true;
            this.originalValue = angular.copy(this.data.selected[0]);
        }

        this.getSubCriteriaData();

        if (this.lastSearch && this.lastSearch.field === this.data.field && this.data.multiple) {
            this.showAdd = true;
            this.filterValues = this.lastSearch.value;

            if (this.lastSearch.subCriteria) {
                this.subCriteriaChosen(this.lastSearch.subCriteria);
            }
        }
        this.updateRequiredItemsIndexes();
    }

    getPriorityType(index) {
        const requitedValue = _.get(this.requiredIndexes, `${index}.requiredValue`, '');

        switch (requitedValue) {
            case 0:
                return 'optional';
            case 1:
                return 'preferred';
            case 2:
                return 'mandatory';
            case 3:
                return 'filter';
            default:
                return '';
        }
    }

    getPriorityClass(index, isDerived) {
        const priority = this.getPriorityType(index);
        const { className } = this.tftTagsService.getTagStyles({ priority, isDerived });

        return className;
    }

    getPriorityStyles(index, isDerived) {
        const priority = this.getPriorityType(index);
        const { styles } = this.tftTagsService.getTagStyles({ priority, isDerived });

        return styles;
    }

    getItemValueToDisplay(item, index) {
        const priority = this.displayMode === 'GROUP_EDIT_MODE' ? this.getPriorityType(index) : '';
        return this.DynamicCriteriaWithGroupsService.getItemValueToDisplay(item, priority);
    }

    getItemTooltip(item) {
        return this.DynamicCriteriaWithGroupsService.getItemTooltip(item);
    }

    onDrop(list, item, index) {
        const itemToMoveIndex = this.DynamicCriteriaWithGroupsService.getMatchedItemIndex({ list, item });

        if (itemToMoveIndex > -1) {
            list.splice(itemToMoveIndex, 1);
            const indexToInsert = index > itemToMoveIndex ? index - 1 : index;
            this.data.selected = list
                .slice(0, indexToInsert)
                .concat(item)
                .concat(list.slice(indexToInsert));
            this.dragedItem = null;
            this.updateRequiredItemsIndexes();
            this.$scope.$apply();
        }
    }

    onDragStart(item) {
        this.dragedItem = item;
        this.selectedItems.clear();
        this.isGroupingActionEnabled = false;
        this.isEditActionEnabled = false;
    }

    onDragEnd() {
        this.dragedItem = null;
    }

    onItemClick(event, item) {
        event.stopImmediatePropagation();
        if (this.disable !== true && this.displayMode !== 'GROUP_EDIT_MODE') {
            this.selectItem(item);
        }
    }

    onItemDoubleClick(event, item) {
        event.stopImmediatePropagation();
        if (this.disable !== true && this.displayMode !== 'GROUP_EDIT_MODE') {
            this.clearSelectedItems();
            this.selectItem(item);
            this.openGroupEditPopup();
        }
    }

    selectItem(item) {
        if (this.disable === true) {
            return;
        }

        if (this.selectedItems.has(item)) {
            this.selectedItems.delete(item);
        } else {
            this.selectedItems.add(item);
        }

        if (this.selectedItems.size > 1) {
            this.isGroupingActionEnabled = true;
        } else {
            this.isGroupingActionEnabled = false;
        }

        const hasGroups = _.some(Array.from(this.selectedItems), (item) => {
            const isGroup = _.has(item, 'group');
            return isGroup;
        });

        if (this.selectedItems.size === 1 && hasGroups) {
            this.isEditActionEnabled = true;
        } else {
            this.isEditActionEnabled = false;
        }
    }

    clearSelectedItems() {
        this.selectedItems.clear();
        this.isEditActionEnabled = false;
        this.isGroupingActionEnabled = false;
    }

    updateRequiredItemsIndexes() {
        this.requiredIndexes = [];
        for (const selectedElement of this.data.selected) {
            const value = this.displayMode === 'GROUP_EDIT_MODE' ? this.groupPriority : selectedElement.required;
            const index = _.findIndex(this.mandatoryValues, { value });

            if (index >= 0) {
                this.requiredIndexes.push({
                    requiredValue: index,
                });
            } else {
                this.requiredIndexes.push({
                    requiredValue: 0,
                });
            }
        }
    }

    groupSelectedItems() {
        const newGroup = {
            required: searchItemsPriority.OPTIONAL,
            group: [],
        };

        const newGroupItems = [];

        const newSelected = [...this.data.selected];

        const selectedItemsArray = Array.from(this.selectedItems);

        const maxItemsPriority = this.DynamicCriteriaWithGroupsService.getMaxItemsPriority(selectedItemsArray);

        newGroup.required = maxItemsPriority || newGroup.required;

        const selectedItemsArraySorted = _.sortBy(selectedItemsArray, (item) => {
            const itemIndex = this.DynamicCriteriaWithGroupsService.getMatchedItemIndex({ list: this.data.selected, item });
            return itemIndex;
        });

        for (const item of selectedItemsArraySorted) {
            _.remove(newSelected, item);
            if (item.hasOwnProperty('group')) {
                for (const groupItem of item.group) {
                    const cleanItem = this.DynamicCriteriaWithGroupsService.cleanUpItemFields(groupItem);
                    newGroupItems.push(cleanItem);
                }
            } else {
                const cleanItem = this.DynamicCriteriaWithGroupsService.cleanUpItemFields(item);
                newGroupItems.push(cleanItem);
            }
        }

        const indexToInsertGroup = _.reduce(selectedItemsArray, (accumulator, item) => {
            const itemIndex = this.DynamicCriteriaWithGroupsService.getMatchedItemIndex({ list: this.data.selected, item });
            const minIndex = itemIndex > accumulator ? accumulator : itemIndex;
            return minIndex;
        }, newSelected.length);

        newGroup.group = newGroupItems;

        this.data.selected = newSelected
            .slice(0, indexToInsertGroup)
            .concat(newGroup)
            .concat(newSelected.slice(indexToInsertGroup));

        this.updateRequiredItemsIndexes();
        this.selectedItems.clear();
        this.isGroupingActionEnabled = false;
        this.isEditActionEnabled = false;
    }

    openGroupEditPopup() {
        const modalInstance = this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'shared/modals/editDynamicCriteriaGroupPopup/template.html',
            controller: 'editCriteriaGroupPopupCtrl',
            controllerAs: 'ctrl',
            windowClass: 'edit-group-criteria',
            backdrop: 'static',
            resolve: {
                field: () => this.data.field,
                data: this.selectedItems,
                onSaveData: () => this.onSaveGroupData.bind(this),
            },
        });
        modalInstance.result.then(() => {}, () => {});
    }

    onSaveGroupData({ originalGroupItem: originalGroup, modifiedGroup, unGroup = false }) {
        const skillCriteriaList = this.data.selected;
        const originalGroupItemIndex = this.DynamicCriteriaWithGroupsService.getMatchedItemIndex({
            list: skillCriteriaList,
            item: originalGroup,
        });

        if (originalGroupItemIndex <= -1) {
            return Logger.error('Group onSaveData: Failed to find original item in list.');
        }

        const skillsRemovedFromGroup = [];
        const modifiedSkillValues = _.map(modifiedGroup.selected, 'value');
        for (const originalSkill of originalGroup.group) {
            if (!modifiedSkillValues.includes(originalSkill.value)) {
                originalSkill.required = originalGroup.required;
                skillsRemovedFromGroup.push(originalSkill);
            }
        }

        const unGroupItems = [];
        if (unGroup) {
            modifiedGroup.selected = [];
            for (const originalSkill of originalGroup.group) {
                const canAddToUngroup = skillsRemovedFromGroup.findIndex(skl => skl.value === originalSkill.value) === -1;
                if (canAddToUngroup) {
                    originalSkill.required = originalGroup.required;
                    unGroupItems.push(originalSkill);
                }
            }
        }

        if (modifiedGroup.selected.length === 1) {
            const oneSkill = modifiedGroup.selected[0];
            oneSkill.required = originalGroup.required;
            unGroupItems.push(oneSkill);
            modifiedGroup.selected = [];
        }

        for (const skill of skillCriteriaList) {
            if (skill === originalGroup) {
                if (_.isEmpty(modifiedGroup.selected)) {
                    _.remove(skillCriteriaList, skill);
                } else {
                    skill.group = modifiedGroup.selected;
                }
            }
        }

        const addedSkills = skillCriteriaList.slice(originalGroupItemIndex);
        const newSelected = skillCriteriaList
            .slice(0, originalGroupItemIndex)
            .concat(unGroupItems)
            .concat(addedSkills);

        this.data.selected = newSelected;
        this.selectedItems.clear();
        this.isGroupingActionEnabled = false;
        this.isEditActionEnabled = false;
        this.updateRequiredItemsIndexes();
    }

    filterValueChosen(value) {
        if (this.data.multiple === false && this.data.selected.length == 1) {
            if (value.id) {
                this.data.selected[0].uid = value.id.toString();
            } else {
                delete this.data.selected[0].uid;
            }
            if (this.data.subCriteria !== null && this.subCriteriaValue) {
                this.data.selected[0].additional = {
                    uid: this.subCriteriaValue.id,
                    value: this.subCriteriaValue.text,
                };
            }
            const isSameText = value.text && (this.data.selected[0].text === value.text);

            if (value.text) {
                this.data.selected[0].text = value.text;
            } else if (value.value) {
                this.data.selected[0].value = value.value;
            }

            if (this.data.field !== 'locations') {
                const havePickedItem = this.data.selected[0].value && this.data.selected[0].text;
                if (havePickedItem) {
                    this.data.selected[0].value = this.data.selected[0].text;
                }
            } else {
                const text = this.data.selected[0].text;
                const locationValue = value.value;
                if (!text) {
                    this.data.selected[0] = locationValue;
                }
                const valueIsCoords = this.utils.isLocationString(locationValue);
                if (valueIsCoords) {
                    this.data.selected[0].value = locationValue;
                } else if (!isSameText) {
                    this.data.selected[0].value = '';
                }
            }

            this.showDropDown = false;
            this.showAdd = false;
            this.filterValues = '';
        } else {
            if (value.id) {
                value.id = value.id.toString();
            }
            const selected = {
                uid: value.id || '0',
                value: value.value || value.text,
                text: value.text,
                required: 'optional',
            };
            if (this.data.subCriteria !== null && this.subCriteriaValue) {
                selected.additional = {
                    uid: this.subCriteriaValue.id,
                    value: this.subCriteriaValue.text,
                };
            }
            const groupValues = _.reduce(this.data.selected, (accumulator, item) => {
                if (_.isArray(item.group)) {
                    const groupValues = _.map(item.group, groupItem => groupItem.value.toLowerCase());
                    accumulator = [...accumulator, ...groupValues];
                }
                return accumulator;
            }, []);

            if (!_.find(this.data.selected, { value: selected.value }) && !groupValues.includes(selected.value.toLowerCase())) {
                (this.onBeforeValueAdded() || (() => {}))(selected);
                this.data.selected.push(selected);
            }
            if (this.data.multiple === true && (this.data.selected.length > 1 || this.doNotHideDropDownAfterSelect)) {
                this.filterChanged();
            } else {
                this.showDropDown = false;
                this.showAdd = false;
                this.filterValues = '';
            }
        }

        this.searchCacheService.saveLastSearchField(this.data.field, this.filterValues, this.subCriteriaValue);
        this.onChange();
    }

    setRequiredSubCriteria(idx) {
        this.mandatoryPopUpView = -1;
        this.data.selected[idx].required = this.newSelected.required;

        const index = _.findIndex(this.mandatoryValues, { value: this.data.selected[idx].required });
        if (this.requiredIndexes.length === 0) {
            if (index >= 0) {
                const items = this.data.selected;
                for (let i = 0; i < items.length; i++) {
                    const importantIdx = _.findIndex(
                        this.mandatoryValues,
                        { value: this.data.selected[i].required },
                    );

                    this.requiredIndexes.push({
                        requiredValue: importantIdx,
                    });
                }

                this.requiredIndexes[idx].requiredValue = index;
            } else {
                this.requiredIndexes.push({
                    requiredValue: 0,
                });
            }
        } else if (index >= 0) {
            if (this.requiredIndexes[idx]) {
                this.requiredIndexes[idx].requiredValue = index;
            } else {
                this.requiredIndexes.push({
                    requiredValue: index,
                });
            }
        } else if (this.requiredIndexes[idx]) {
            this.requiredIndexes[idx].requiredValue = 0;
        } else {
            this.requiredIndexes.push({
                requiredValue: index,
            });
        }
        const subCriterita = _.find(this.dynamicSubCriteriaData, { text: this.newSelected.additional });
        if (subCriterita) {
            this.subCriteriaValue = subCriterita;
            this.data.selected[idx].additional = {
                uid: this.subCriteriaValue.id,
                value: this.subCriteriaValue.text,
            };
            delete this.data.selected[idx].status;
        }
    }
}

export const config = {
    bindings: {
        ...DynamicCriteriaComponentConfiguration.bindings,
        showTitle: '<',
        displayMode: '<',
        groupPriority: '<',
    },
    controller: DynamicCriteriaWithGroupsComponent,
    template,
    controllerAs: 'dynamicCriteriaWithGroupsCtrl',
};

angular
    .module('TALENYA-FE')
    .component('dynamicCriteriaWithGroups', config);
